module.exports = __webpack_public_path__ + "media/linkedin-promo.6266a015.mp4";